/* Royal Bin® NOIR 17L landing, sections 2 to 7. Shared behaviour, written for this page.
   Scroll-scrubbed video, scroll-scrubbed image sequences (round 3), play-in-view video, reviews autoplay (round 3), staggered reveals, gallery paddles, FAQ accordion, Add to Cart.
   Loaded once even if several sections include it. */
(function () {
  'use strict';
  if (window.__nlsInit) return; window.__nlsInit = true;
  var mq = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : { matches: false };
  var RM = mq.matches;
  var IO = 'IntersectionObserver' in window;

  function init() {
    var roots = document.querySelectorAll('.nls');
    roots.forEach(function (r) { r.classList.add('nls-js'); if (RM) r.classList.add('nls-rm'); });
    reveals(); scrubbers(); sequences(); inview(); galleries(); faqs(); atc();
  }

  /* Staggered fade-in */
  function reveals() {
    var els = document.querySelectorAll('.nls .nls-r');
    if (RM || !IO) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } }); }, { rootMargin: '0px 0px -12% 0px' });
    els.forEach(function (e) { io.observe(e); });
  }

  /* Lazy source: attach <source>/src only when close to the viewport */
  function loadVideo(v) {
    if (!v || v.dataset.loaded) return; v.dataset.loaded = '1';
    var webm = v.dataset.webm, mp4 = v.dataset.mp4;
    if (webm && v.canPlayType('video/webm; codecs="vp9"')) v.src = webm; else v.src = mp4;
    v.muted = true; v.playsInline = true; v.setAttribute('playsinline', ''); v.setAttribute('muted', '');
    v.preload = 'auto'; v.load();
    v.addEventListener('loadeddata', function () { v.classList.add('is-ready'); }, { once: true });
  }
  function near(el, cb) {
    if (!IO) { cb(); return; }
    var io = new IntersectionObserver(function (es) { if (es[0].isIntersecting) { io.disconnect(); cb(); } }, { rootMargin: '150% 0px 150% 0px' });
    io.observe(el);
  }

  /* Scroll scrub: progress of a pinned zone drives video.currentTime and CSS --p */
  function scrubbers() {
    var list = [];
    document.querySelectorAll('[data-nls-scrub]').forEach(function (track) {
      var vs = Array.prototype.slice.call(track.querySelectorAll('video[data-nls-scrub-video]'));
      var pin = track.querySelector('[data-nls-pin]');
      var o = { track: track, pin: pin, vs: vs, seg: -1, p: -1, t: 0, lists: track.querySelectorAll('.nls-steps'), stage: track.querySelector('[data-nls-stage]'), split: parseFloat(track.dataset.split || '0') };
      if (RM) { return; }
      near(track, function () {
        vs.forEach(function (v) {
          loadVideo(v);
          v.addEventListener('loadeddata', function () {
            /* iOS Safari paints seeks more reliably after one muted play/pause */
            var pr = v.play(); if (pr && pr.then) pr.then(function () { v.pause(); o.seg = -1; seek(o); }).catch(function () {}); else v.pause();
          }, { once: true });
        });
      });
      list.push(o);
    });
    if (!list.length) return;
    var ticking = false;
    function zone(o) { return (o.pin && getComputedStyle(o.pin).display !== 'contents') ? o.pin : o.track; }
    /* SPACING FIX (2026-10-24): the pinned stage may be shorter than the screen and stick below the top.
       Progress runs 0 to 1 while it is stuck: p = (stickyTop - zoneTop) / (zoneHeight - stageHeight). With a full-screen stage at top 0 this is the old formula. */
    function stuck(o) { var s = o.stickEl || (o.stickEl = o.track.querySelector('.nls-seal-stage, [data-nls-stage]')); if (!s) return null; var cs = getComputedStyle(s); if (cs.position !== 'sticky') return null; return { t: parseFloat(cs.top) || 0, h: s.offsetHeight }; }
    function update() {
      ticking = false;
      var vh = window.innerHeight;
      list.forEach(function (o) {
        var z = zone(o), r = z.getBoundingClientRect();
        if (r.bottom < -vh || r.top > vh * 2) return;
        var sk = stuck(o), st0 = sk ? sk.t : 0, sh = sk ? sk.h : vh;
        var p = Math.min(1, Math.max(0, (st0 - r.top) / Math.max(1, r.height - sh)));
        if (Math.abs(p - o.p) < 0.0005) return;
        o.p = p; o.track.style.setProperty('--p', p.toFixed(4));
        o.lists.forEach(function (l) {
          var st = l.querySelectorAll('[data-nls-step]'), n = st.length;
          st.forEach(function (s, i) {
            var f = Math.min(1, Math.max(0, p * n - i));
            s.style.setProperty('--f', f.toFixed(3));
            s.classList.toggle('is-on', p * n >= i && (p * n < i + 1 || i === n - 1));
          });
        });
        if (o.stage && o.split) o.stage.classList.toggle('is-b', p >= o.split);
        seek(o);
      });
    }
    function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(update); } }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    update();
  }

  /* ROUND 3: scroll-scrubbed image sequence from one sprite sheet.
     Inside a [data-nls-scrub] track it follows the track's --p; with data-nls-seq-view it follows its own pass through the viewport. */
  function sequences() {
    if (RM) return;
    document.querySelectorAll('[data-nls-seq]').forEach(function (box) {
      var n = +box.dataset.frames || 1, cols = +box.dataset.cols || 1, rows = +box.dataset.rows || Math.ceil(n / cols);
      var track = box.closest('[data-nls-scrub]'), own = box.hasAttribute('data-nls-seq-view') || !track;
      var f = document.createElement('div'), cur = -1, ready = false, ticking = false;
      f.className = 'nls-seq-f'; f.setAttribute('aria-hidden', 'true');
      f.style.backgroundSize = (cols * 100) + '% ' + (rows * 100) + '%';
      function prog() {
        if (!own) return parseFloat(track.style.getPropertyValue('--p')) || 0;
        var r = box.getBoundingClientRect(), vh = window.innerHeight, a = vh * 0.9, b = vh * 0.35 - r.height / 2;
        return Math.min(1, Math.max(0, (a - r.top) / Math.max(1, a - b)));
      }
      function draw() {
        ticking = false; if (!ready) return;
        var i = Math.min(n - 1, Math.max(0, Math.round(prog() * (n - 1))));
        if (i === cur) return; cur = i;
        var c = i % cols, rr = Math.floor(i / cols);
        f.style.backgroundPosition = (cols > 1 ? c / (cols - 1) * 100 : 0) + '% ' + (rows > 1 ? rr / (rows - 1) * 100 : 0) + '%';
      }
      function on() { if (!ticking) { ticking = true; requestAnimationFrame(draw); } }
      near(box, function () {
        var im = new Image();
        im.onload = function () { f.style.backgroundImage = 'url("' + box.dataset.sprite + '")'; ready = true; draw(); box.appendChild(f); box.classList.add('is-ready'); };
        im.src = box.dataset.sprite;
      });
      window.addEventListener('scroll', on, { passive: true });
      window.addEventListener('resize', on);
    });
  }
  /* The clip is split into equal segments (one <video> each, to keep every file small); the active one is seeked, the rest wait at their edges */
  function seek(o) {
    var n = o.vs.length; if (!n || o.p < 0) return;
    var x = o.p * n, i = Math.min(n - 1, Math.floor(x)), local = Math.min(1, x - i);
    if (i !== o.seg) {
      o.seg = i;
      o.vs.forEach(function (v, j) {
        v.classList.toggle('is-active', j === i);
        if (j !== i && v.duration) { var edge = j < i ? v.duration - 0.04 : 0; if (Math.abs(v.currentTime - edge) > 0.02) { try { v.currentTime = edge; } catch (e) {} } }
      });
    }
    var v = o.vs[i]; if (!v.duration || isNaN(v.duration)) return;
    var t = Math.max(0, Math.min(v.duration - 0.04, local * v.duration));
    if (Math.abs(v.currentTime - t) > 0.016) { try { v.currentTime = t; } catch (e) {} }
  }

  /* In-view video (wave): loops continuously while on screen, muted and inline, no control button (Oct 24, Founder).
     It pauses only while off screen to save battery and resumes when back. Reduced motion: the poster stays as a still. */
  function inview() {
    document.querySelectorAll('[data-nls-inview]').forEach(function (box) {
      var v = box.querySelector('video');
      if (!v) return;
      v.loop = true; v.muted = true; v.playsInline = true;
      if (RM) return;
      function go() { var pr = v.play(); if (pr && pr.catch) pr.catch(function () {}); }
      near(box, function () { loadVideo(v); });
      if (!IO) { loadVideo(v); go(); return; }
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          if (e.isIntersecting) { loadVideo(v); if (v.readyState >= 2) go(); else v.addEventListener('loadeddata', go, { once: true }); }
          else if (!v.paused) { v.pause(); }
        });
      }, { threshold: 0 });
      io.observe(box);
      v.addEventListener('ended', function () { v.currentTime = 0; go(); });
    });
  }

  /* Horizontal galleries: paddle buttons */
  function galleries() {
    document.querySelectorAll('[data-nls-gallery]').forEach(function (g) {
      var sc = g.querySelector('[data-nls-gallery-scroll]'), prev = g.querySelector('[data-nls-prev]'), next = g.querySelector('[data-nls-next]');
      if (!sc || !prev || !next) return;
      function step() { var c = sc.querySelector(':scope > *'); return c ? c.getBoundingClientRect().width + 20 : 300; }
      function sync() { prev.disabled = sc.scrollLeft <= 4; next.disabled = sc.scrollLeft + sc.clientWidth >= sc.scrollWidth - 4; }
      prev.addEventListener('click', function () { sc.scrollBy({ left: -step(), behavior: RM ? 'auto' : 'smooth' }); });
      autoplay(g, sc, step);
      next.addEventListener('click', function () { sc.scrollBy({ left: step(), behavior: RM ? 'auto' : 'smooth' }); });
      sc.addEventListener('scroll', function () { requestAnimationFrame(sync); }, { passive: true });
      window.addEventListener('resize', sync); sync();
    });
  }


  /* ROUND 3: reviews auto-advance one card every 3.5 s and loop. Pauses on hover, touch, keyboard focus, when off screen,
     when the tab is hidden, and with the Pause button. Off for reduced motion. Scrolling only, so no layout shift. */
  function autoplay(g, sc, step) {
    if (!g.hasAttribute('data-nls-autoplay') || RM) return;
    var btn = g.querySelector('[data-nls-autoplay-btn]'), hold = { hover: 0, touch: 0, focus: 0, view: 1, user: 0 }, timer = null, touchT = null;
    function paused() { return hold.hover || hold.touch || hold.focus || hold.view || hold.user || document.hidden; }
    function tick() {
      if (paused()) return;
      var end = sc.scrollLeft + sc.clientWidth >= sc.scrollWidth - 4;
      sc.scrollTo({ left: end ? 0 : sc.scrollLeft + step(), behavior: 'smooth' });
    }
    function sync() { if (btn) { btn.textContent = hold.user ? 'Play' : 'Pause'; btn.setAttribute('aria-label', hold.user ? 'Play review carousel' : 'Pause review carousel'); btn.setAttribute('aria-pressed', hold.user ? 'true' : 'false'); } }
    timer = setInterval(tick, 3500);
    g.addEventListener('mouseenter', function () { hold.hover = 1; });
    g.addEventListener('mouseleave', function () { hold.hover = 0; });
    sc.addEventListener('touchstart', function () { hold.touch = 1; clearTimeout(touchT); }, { passive: true });
    sc.addEventListener('touchend', function () { clearTimeout(touchT); touchT = setTimeout(function () { hold.touch = 0; }, 6000); }, { passive: true });
    g.addEventListener('focusin', function (e) { if (e.target !== btn) hold.focus = 1; });
    g.addEventListener('focusout', function () { hold.focus = 0; });
    if (btn) { btn.hidden = false; btn.addEventListener('click', function () { hold.user = hold.user ? 0 : 1; sync(); }); sync(); }
    if (IO) { new IntersectionObserver(function (es) { hold.view = es[0].isIntersecting ? 0 : 1; }, { threshold: 0.35 }).observe(sc); } else hold.view = 0;
  }

  /* FAQ accordion with Expand all */
  function faqs() {
    document.querySelectorAll('[data-nls-faq]').forEach(function (f) {
      var items = f.querySelectorAll('.nls-acc > li'), all = f.querySelector('[data-nls-faq-all]');
      function open(li, on) { li.classList.toggle('is-open', on); var b = li.querySelector('button'); b.setAttribute('aria-expanded', on ? 'true' : 'false'); li.querySelector('.a').setAttribute('aria-hidden', on ? 'false' : 'true'); }
      function syncAll() { if (!all) return; var every = Array.prototype.every.call(items, function (li) { return li.classList.contains('is-open'); }); all.textContent = every ? 'Collapse all' : 'Expand all'; all.setAttribute('aria-expanded', every ? 'true' : 'false'); }
      items.forEach(function (li) { li.querySelector('button').addEventListener('click', function () { open(li, !li.classList.contains('is-open')); syncAll(); }); });
      if (all) all.addEventListener('click', function () { var every = all.getAttribute('aria-expanded') === 'true'; items.forEach(function (li) { open(li, !every); }); syncAll(); });
    });
  }

  /* Add to Cart: same path as the hero.
     1) Instant Cart on the page: window.Instant.api.addToCart([{id, quantity:1}], {openCart:true})
     2) Theme fallback: POST /cart/add.js, refreshCartContents, open #offcanvas-cart
     3) Last resort: /cart */
  function atc() {
    function busy(b, on, label) { if (on) { b.setAttribute('aria-busy', 'true'); b.textContent = 'Adding...'; } else { b.removeAttribute('aria-busy'); b.textContent = label || 'Add to Cart'; } }
    function reset(b) { setTimeout(function () { b.textContent = 'Add to Cart'; }, 2000); }
    function themeDrawer() { var oc = document.querySelector('#offcanvas-cart'); if (oc && window.bootstrap && window.bootstrap.Offcanvas) { window.bootstrap.Offcanvas.getOrCreateInstance(oc).show(); return true; } return false; }
    function add(b) {
      var id = +b.dataset.variantId; busy(b, true);
      var instant = window.Instant && window.Instant.api && typeof window.Instant.api.addToCart === 'function' && document.querySelector('[data-instant-layout="CART"]');
      if (instant) {
        return window.Instant.api.addToCart([{ id: id, quantity: 1 }], { openCart: true })
          .then(function (r) { busy(b, false, r && r.success ? 'Added' : 'Try again'); reset(b); })
          .catch(function () { location.href = '/cart'; });
      }
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [{ id: id, quantity: 1 }] }) })
        .then(function (res) { var p = typeof window.refreshCartContents === 'function' ? window.refreshCartContents(res.clone()) : null; return Promise.resolve(p).then(function () { return res.json(); }).then(function (d) { return { ok: res.ok, data: d }; }); })
        .then(function (r) { busy(b, false, r.ok ? 'Added' : 'Try again'); reset(b); if (!r.ok) return; document.dispatchEvent(new CustomEvent('noir:added-to-cart', { detail: r.data })); if (!themeDrawer()) location.href = '/cart'; })
        .catch(function () { location.href = '/cart'; });
    }
    document.querySelectorAll('.nls [data-nls-atc]').forEach(function (b) { b.addEventListener('click', function () { add(b); }); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
